import Vue from 'vue'
import App from './App'
import router from './router'

import store from './store/store.js';
import 'lib-flexible/flexible'
import 'mint-ui/lib/style.css'
import '../static/css/font.css'
import '../static/iconfont/iconfont.css'
import 'jquery'
import '../node_modules/swiper/dist/css/swiper.min.css';
import '../node_modules/swiper/dist/js/swiper.min.js';
import axios from 'axios';
Vue.prototype.$axios = axios;
import $tool from './common/tool.js';
import Bridge from './common/bridge.js'
import Moment from 'moment'
import fetchql from './common/fetch.js'
import {
  baseUrl,
  language,
} from './common/env.js'
import $store from "./common/store.js";
import directives from './directives'
import filters from './filters'
import './icons' // icon
import Videojs from 'video.js'
import 'video.js/dist/video-js.css'
import VueImageSwipe from 'vue-image-swipe'
import 'vue-image-swipe/dist/vue-image-swipe.css'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)


Vue.use(VueImageSwipe); //图片预览
import FastClick from 'fastclick'
FastClick.attach(document.body); //移动端点击延迟事件
import Vconsole from 'vconsole';
Vue.prototype.$video = Videojs
Vue.prototype.$fetchql = fetchql.fetchql; // 其他页面在使用 fetchql 的时候直接  this.$fetchql 就可以了
Vue.prototype.$bridge = Bridge
Vue.prototype.$moment = Moment

Vue.prototype.$baseUrl = "https://cdn.mintstech.cn/images/"

Vue.prototype.$baseRequest = baseUrl
Vue.prototype.$tool = $tool;
Vue.prototype.$store = $store;
Vue.prototype.$storeS = store
Vue.config.productionTip = false
Vue.prototype.$language = language;


// 引入全局样式
import './styles/index.css'

// 注册全局插件
import plugins from '@/plugins'
Vue.use(plugins)


import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
//echarts图表
const echarts = require('echarts');
Vue.prototype.$echarts = echarts
//视频插件
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')



Vue.use(VideoPlayer)
import {
  Button,
  Header,
  Popup,
  Field,
  Radio,
  Range,
  Navbar,
  TabItem,
  Cell,
  TabContainer,
  TabContainerItem,
  InfiniteScroll,
  Toast,
  Search,
  Badge,
  Indicator,
  MessageBox,
  Picker,
} from 'mint-ui';
Vue.component(Button.name, Button);
Vue.component(Header.name, Header);
Vue.component(Popup.name, Popup);
Vue.component(Field.name, Field);
Vue.component(Picker.name, Picker);
Vue.component(Radio.name, Radio);
Vue.component(Range.name, Range);
Vue.component(Navbar.name, Navbar);
Vue.component(TabItem.name, TabItem);
Vue.component(Cell.name, Cell);
Vue.component(TabContainer.name, TabContainer);
Vue.component(Search.name, Search);
Vue.component(TabContainerItem.name, TabContainerItem);
Vue.component(Badge.name, Badge);

Vue.prototype.$messagebox = MessageBox
Vue.use(InfiniteScroll);
Vue.prototype.$toast = Toast
Vue.prototype.Indicator = Indicator
Vue.use(directives)
Vue.use(filters)
Vue.config.ignoredElements = ['wx-open-launch-weapp']
Vue.prototype.ModalHelper = (function (bodyCls) {
  var scrollTop
  return {
    afterOpen: function () {
      scrollTop = document.scrollingElement.scrollTop
      document.body.classList.add(bodyCls)
      document.body.style.top = -scrollTop + 'px'
    },
    beforeClose: function () {
      document.body.classList.remove(bodyCls)
      // scrollTop lost after set position:fixed, restore it back.
      document.scrollingElement.scrollTop = scrollTop
    }
  }
}('dialog-open'))
//  this.$store.setstate.isShowPer(false)


// if (localStorage.getItem("lang") != "zh-cn") {
//   router.beforeEach((to, from, next) => {
//     if (localStorage.getItem('key') == 'mints20220818') {
//       next();
//     } else {
//       //如果是登录页面路径，就直接next()
//       if (to.path === '/popup') {
//         next();
//       } else {
//         next('/popup');
//       }
//     }
//   })
// }


import i18n from "./i18n/index.js"
Vue.prototype.$i18nn = i18n
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  i18n,
})



// WEBPACK FOOTER //
// ./src/main.js